import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Box } from '@chakra-ui/react';
import { cloneElement, useEffect, useState } from 'react';
import Slider from 'react-slick';
import CarouselGlobalStyles from '../../theme/components/CarouselGlobalStyles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function MobileCarousel(_ref) {
  var children = _ref.children,
    thumbnails = _ref.thumbnails,
    activeSlide = _ref.activeSlide,
    setActiveSlide = _ref.setActiveSlide;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    nav1 = _useState2[0],
    setNav1 = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    nav2 = _useState4[0],
    setNav2 = _useState4[1];
  useEffect(() => {
    focusSlider(nav1);
  }, [nav1]);
  return _jsxs(Box, {
    "data-testid": "mobileCarousel-".concat(activeSlide + 1, "/").concat(children === null || children === void 0 ? void 0 : children.length),
    sx: {
      '& .carousel-thumbnails': {
        marginTop: 'md',
        cursor: 'pointer',
        '.slick-slide': {
          width: 'calc(100% - 1rem)',
          padding: '0 0.5rem'
        },
        '.slick-current > div > *': {
          border: '2px solid var(--chakra-colors-darkGrey1)',
          padding: '2px'
        }
      }
    },
    children: [_jsx(CarouselGlobalStyles, {}), _jsx(Slider, {
      asNavFor: nav2,
      ref: slider => setNav1(slider),
      initialSlide: activeSlide,
      infinite: false,
      arrows: false,
      speed: 300,
      afterChange: index => setActiveSlide(index),
      children: children
    }), _jsx(Slider, {
      className: "carousel-thumbnails",
      asNavFor: nav1,
      ref: slider => setNav2(slider),
      initialSlide: activeSlide,
      speed: 300,
      infinite: false,
      arrows: false,
      slidesToShow: 3,
      focusOnSelect: true,
      swipeToSlide: true,
      children: thumbnails === null || thumbnails === void 0 ? void 0 : thumbnails.map((thumbnail, index) => cloneElement(thumbnail, {
        key: index
      }, null))
    })]
  });
}
function focusSlider(sliderRef) {
  if (sliderRef !== null && sliderRef !== void 0 && sliderRef.innerSlider) {
    var _sliderRef$innerSlide;
    var track = (_sliderRef$innerSlide = sliderRef.innerSlider.list) === null || _sliderRef$innerSlide === void 0 ? void 0 : _sliderRef$innerSlide.querySelector('.slick-track');
    var slide = track === null || track === void 0 ? void 0 : track.querySelector('.slick-slide');
    slide === null || slide === void 0 || slide.focus();
  }
}